import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';

@Component({
  selector: 'app-vehicle-fingerprint-speed-profile',
  templateUrl: './speed-profile.component.html',
  styleUrls: ['./speed-profile.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintSpeedProfileComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  readonly bands = [
    { field: 'fSpeedUnder10Ratio', name: 'زیر 10', label: 'کمتر از 10', color: '#39d9b2', cssClass: 'green' },
    { field: 'fSpeed10To30Ratio', name: '\u200e10–30\u200e', label: '10 تا 30', color: '#35d7ed', cssClass: 'cyan' },
    { field: 'fSpeed30To60Ratio', name: '\u200e30–60\u200e', label: '30 تا 60', color: '#6ca8ff', cssClass: 'blue' },
    { field: 'fSpeedOver60Ratio', name: 'بالای 60', label: 'بیشتر از 60', color: '#a98aff', cssClass: 'purple' },
  ] as const;

  chartContext: ChartContext = {
    type: 'bar',
    title: 'پروفایل سرعت',
    showTitle: false,
    data: [],
    colors: this.bands.map(band => band.color),
    unit: '%',
    theme: 'dark',
    max: 100,
    showValues: true,
  };

  ngOnChanges(): void {
    const data = this.bands.map(band => ({
      name: band.name,
      value: this.context.summary?.[band.field],
    }));
    const valid = data.every(item => typeof item.value === 'number'
      && Number.isFinite(item.value) && item.value >= 0 && item.value <= 100);
    this.chartContext = { ...this.chartContext, data: valid ? data : [] };
  }
}
